import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
} from "@mui/material";
import { JumboCard } from "themes/jumbo/@jumbo/components";
import { PendingItem, EmptyPendingItem } from "./PendingItem";
import { useSelector } from 'react-redux';
import { tss } from "tss-react";
import { FoldersActions } from "actions";
import { useHistory } from 'react-router-dom';
import { getFileIcon } from "actions/GlobalActions";

const useStyles = tss.create(() => ({
  tableTr: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    textAlign: 'left',
    padding: '16px',
    color: 'rgb(71, 82, 89)',
    borderTopColor: 'rgba(0, 0, 0, 0.1)',
    borderRightColor: 'rgba(0, 0, 0, 0.1)',
    bordTransform: 'uppercase',
    letterSpacing: '1.5px',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: 1.25,
    background: 'rgba(0, 0, 0, .08)'
  }
}));

const define_status = (str: string) => {
  return typeof str === "string" && str.length > 0 ? str : "Pending processing...";
};

const PendingList = (props:any) => {
  const {nb} = props
	const data = useSelector((state: any) => state.cache.data);
  const entities = data.entities;
  const projects = data.projects;
  const { classes } = useStyles();
  const issuesData: any[] = [];
  const history = useHistory();
  const _list = [...Object.entries(entities)];
  
  const storeAuthData = useSelector((state: any) => state.auth);
  const { defaultProjects } = storeAuthData;
  const demoProjectsHidden = Number(localStorage.getItem('hideDemoProjects') || 0) > 0;
  let list = _list.filter((entry: any) => /*!demoProjectsHidden || */!defaultProjects.includes(entry[0])) 

  list.map((entry: any, index: number) => {
    const id = entry[0];
    const pending: any = Object.values(entry[1]).filter((p: any) => {
      return p.state === "PARTIAL" && p.type === "FILE" && p.name;
    });
    if (!projects[id] || pending.length < 1) return;
    pending.map((p: any, index: number) => {
      if(!p) return;
      const workflow = FoldersActions.getWorkflowFromEntity(p);
      const status = typeof p["partial_status"] === "string" && p["partial_status"].length > 0
        ? define_status(p["partial_status"])
        : "Waiting in queue...";

      const isProgress = typeof p["partial_status"] === "string" && p["partial_status"].length > 0;

      issuesData.push({
        projectID: id,
        projectName: projects[id].name,
        path: FoldersActions.getPathFromEntity(p),
        workflow,
        products: (workflow?.products || []).join(" - "),
        date: p.file_date,
        fileName: getFileIcon(p),
        name: p.name,
        status,
        isProgress,
        progress: parseInt(p["partial_progress"]) || 0,
      })
    })

  });

  const handleClick = (e: any) => {
      history.push(`/pending`);
  };

  return (
    <JumboCard>
      <TableContainer sx={{height: '420px'}}>
        <Table /*sx={{ minWidth: 400 }}*/>
          <TableHead>
            <TableRow
              sx={{
                "th:first-of-type": {
                  pl: 3,
                },
                "th:last-child": {
                  pr: 3,
                },
              }}
            >
              <TableCell className={classes.tableTr}>PENDING {nb > 0 ? `(${nb})` : ''}</TableCell>
              {/*<TableCell className={classes.tableTr}></TableCell>*/}
              <TableCell className={classes.tableTr} style={{textAlign: 'right'}}>
              <Button
                size={'small'}
                variant='outlined'
                onClick={handleClick}
              >
                See All
              </Button>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {issuesData.length > 0 ?  (
              issuesData.sort((a:any, b:any) => b.date - a.date).slice(0, 6).map((item: any, index: Number) => (
                <PendingItem item={item} key={`${item.ID}-${index}`} index={index} />
              ))
            ) : (
              <EmptyPendingItem />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </JumboCard>
  );
};
export { PendingList };
